/**
 * Created by Astha on 7/10/2019.
 */
import React from 'react';
import Draggable from './Draggable';
import Resizable from './Resizable';
import Authenticator from '../../protocol/Authenticator';
import "./TextSvg.css";
import { Dimensions } from '../../components/WithAiData';
import ToolTip from '../../common/AssetPropertyView';
const getRect = (props) => {
  const { x, y, width, height, strockColor } = props.data;
  return {
    x: x,
    y: y,
    width: width,
    height: height,
    strockColor: strockColor
  };
};

const getShape = (props, rect) => {
  const { x, y, width, height } = rect;
  return {
    x: x + 5,
    y: y + 5,
    width: width - 10,
    height: height - 10
  };
};

export type SvgBoxData = {
  value: string,
  x: number,
  y: number,
  width: number,
  height: number,
  strokeWidth: number,
  points: Array<number>,
  stroke: number,
  creator: string,
  strockColor: string,
  dimensions: Dimensions
};

type State = {};

type Props = {
  data: SvgBoxData,
  isActive: boolean,
  showDotted: boolean,
  resizable: boolean
};
@Draggable(getRect, getShape)
@Resizable(getRect, getShape)
export default class TextSvg extends React.Component<Props, State> {
  render() {
    let { data, isActive, renderDragNode, renderResizeNodes, showDotted, resizable } = this.props;

    let additionalProps = {
      name: 'TextSvg'
    };

    if (Authenticator.AUTH_DATA.isMe(data.creator)) {
      additionalProps.className = 'selectable';
      additionalProps.onClick = this.onClick;
    }

    const node = renderTextSvg(data, additionalProps, isActive);
    if (!isActive && !showDotted) {
      return node;
    }

    const node1 = renderTextSvgOnClick(data, additionalProps, isActive);
    if (isActive && showDotted) {
      return node1;
    }
    return node;
    //return renderResizeNodes(renderDragNode(node));
  }

  onClick = (e: Event) => {
    const { data, isActive, setActiveShapeId } = this.props;
    if (!isActive) {
      setActiveShapeId(data.id);
    }

    this.props.onClick(event, data);
  };
}


export function renderTextSvg(data: SvgBoxData, additionalProps = {}, isActive: boolean) {
  const stroke = isActive ? data.strockColor : data.stroke;
  const fill = isActive ? "#7a7a7a" : "#685ceb";
  const y = getYPos(data.y);
  const dimensionY = y.box + data.height + 20;
  const dimensions_HW = `H: ${data.dimensions.height.toFixed(2)}, W: ${data.dimensions.width.toFixed(2)}`;
  const dimensions_XY = `X: ${data.dimensions.x.toFixed(2)}, Y: ${data.dimensions.y.toFixed(2)}`
  return (
    <g onClick={additionalProps.onClick}>
      <polygon points={data.points} fill="transparent" stroke={stroke} strokeDasharray={isActive ? '4' : '0'} strokeWidth={2} />
      {data.value ?
        <foreignObject x={data.textProps.x} y={y.box} dominantBaseline="central" width={data.textProps.textWidth} height="18">
          <div style={{ backgroundColor: fill }} className={data.textProps.isRight ? "textSvgRight" : "textSvg"}>
            {data.value}
          </div>
        </foreignObject> : null
      }
      {data.showDimension ?
        <foreignObject x={data.dimensions.x} y= {dimensionY} width={150} dominantBaseline="central" height="40">
          <div style={{ backgroundColor: fill }} className={data.textProps.isRight ? "textSvgRight dimensions" : "textSvg dimensions"}>
              <div className="dimensions">
                <ToolTip text={dimensions_HW}>
                <div className="flex-row">{dimensions_HW}</div>
                </ToolTip>
                <ToolTip text={dimensions_XY}>
                <div className="flex-row">{dimensions_XY}</div>
                </ToolTip>
              </div>   
          </div>
        </foreignObject> : null
      }
    </g >
  );
}

export function renderTextSvgOnClick(data, additionalProps = {}, isActive: boolean) {
  const { x, y, width, height, strokeWidth, stroke, fill, value, strockColor } = data;

  const props = {
    x,
    y,
    width,
    height,
    strokeWidth,
    stroke,
    fill,
    ...additionalProps
  };

  const widthOfText = calculateWidthOfText(value);
  return (
    <g onClick={additionalProps.onClick}>
      {value ? <rect x={data.x} y={data.y - 18} width={widthOfText} height="18" fill="#b5b5b5" /> : null}
      <text
        textAnchor="centre"
        fill="#ffffff"
        fontSize="14"
        fontFamily="Verdana"
        x={data.x + 7}
        y={data.y - 10}
        alignmentBaseline="central">
        {value}
      </text>
      <polygon points={data.points} fill="transparent" stroke="#ffffff00" strokeDasharray="5 4" strokeWidth={1} />
    </g>
  );
}
export function calculateWidthOfText(value: string): number {
  const lengthOfValue = value ? value.length : 0;
  return lengthOfValue * 10 + 20;
}

function getYPos(y: number): boolean {
  if (y > 18) {
    return { box: y - 18, text: y - 10 }
  } else {
    return { box: y, text: y + 10 }
  }
}
